import { $ } from 'jquery';
import { lay } from '../core/lay.js';
import { i18n } from '../core/i18n.js';
import { componentBuilder } from '../core/component.js';
import { layer } from './layer.js';

i18n.set({
  messages: {
    'zh-CN': {
      selectY: {
        placeholder: '请选择：',
        configError: '数据接口错误，请正确配置',
      },
    },
    'en-US': {
      selectY: {
        placeholder: 'Please select:',
        configError: 'Invalid data interface configuration',
      },
    },
  },
});

var t = function (key, fallback, params) {
  return i18n.translate('selectY.' + key, params, { default: fallback });
};

var escapeHtml = function (value) {
  return value == null
    ? ''
    : String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
};

var component = componentBuilder({
  name: 'selectY',

  config: {
    elem: '',
    data: [],
    id: 0,
    url: '',
    placeholder: '',
    disabledTips: '',
    type: 'absolute',
    change: function () {},
    success: function () {},
  },

  beforeRender: function (options) {
    options.placeholder = options.placeholder || t('placeholder', '请选择：');
    options.data = options.url ? this.getData(options.url) : options.data || [];
  },
});

var Class = component.Class;
var CONST = {
  ROOT: 'selectY-box',
  SHOW: 'show',
  SHOW_TEXT: 'cl-exp',
  POP: 'pop',
  STATIC_POP: 'static-pop',
  ACTIVE: 'active',
  CHILD: 'child-row',
  DISABLED: 'layui-disabled',
};

Class.prototype.getData = function (url) {
  var result = [];

  $.ajax({
    url: url,
    type: 'get',
    dataType: 'json',
    async: false,
    success: function (response) {
      result = response && response.data ? response.data : [];
      if (!response || !response.data) {
        layer.msg(t('configError', '数据接口错误，请正确配置'));
      }
    },
    error: function () {
      layer.msg(t('configError', '数据接口错误，请正确配置'));
      result = [];
    },
  });

  return Array.isArray(result) ? result : [];
};

Class.prototype.getChildren = function (pid) {
  var data = this.config.data || [];
  var children = [];

  for (var i = 0; i < data.length; i++) {
    if (String(data[i].pid) == String(pid)) {
      children.push(data[i]);
    }
  }

  return children;
};

Class.prototype.hasChildren = function (id) {
  return this.getChildren(id).length > 0;
};

Class.prototype.renderColumn = function (pid) {
  var that = this;
  var items = that.getChildren(pid);

  if (!items.length) {
    return '';
  }

  var html = '<ul>';

  for (var i = 0; i < items.length; i++) {
    var item = items[i] || {};
    var classes = [];

    if (that.hasChildren(item.id)) {
      classes.push(CONST.CHILD);
    }
    if (item.off) {
      classes.push(CONST.DISABLED);
    }

    html +=
      '<li class="' +
      classes.join(' ') +
      '" data-id="' +
      escapeHtml(item.id) +
      '" data-name="' +
      escapeHtml(item.name) +
      '" data-url="' +
      escapeHtml(item.url) +
      '" data-rate="' +
      escapeHtml(item.rate) +
      '" data-model="' +
      escapeHtml(item.model) +
      '">' +
      escapeHtml(item.title) +
      '</li>';
  }

  html += '</ul>';
  return html;
};

Class.prototype.resolveSelectedIds = function (titles) {
  var that = this;
  var values = Array.isArray(titles) ? titles : [];
  var ids = [];
  var currentPid = that.config.id;

  for (var i = 0; i < values.length; i++) {
    var currentTitle = values[i];
    var children = that.getChildren(currentPid);
    var matched = null;

    for (var j = 0; j < children.length; j++) {
      if (String(children[j].title) === String(currentTitle)) {
        matched = children[j];
        break;
      }
    }

    if (!matched) {
      for (j = 0; j < (that.config.data || []).length; j++) {
        if (String(that.config.data[j].title) === String(currentTitle)) {
          matched = that.config.data[j];
          break;
        }
      }
    }

    if (!matched) {
      break;
    }

    ids.push(String(matched.id));
    currentPid = matched.id;
  }

  return ids;
};

Class.prototype.getSelectedItems = function () {
  var items = [];

  this.elemBox.find('.' + CONST.POP + ' li.' + CONST.ACTIVE).each(function () {
    var item = $(this);
    items.push({
      id: item.data('id'),
      name: item.data('name'),
      title: item.text(),
      url: item.data('url'),
      rate: item.data('rate'),
      model: item.data('model'),
      hasChildren: item.hasClass(CONST.CHILD),
    });
  });

  return items;
};

Class.prototype.updateDisplay = function () {
  var that = this;
  var options = that.config;
  var selected = that.getSelectedItems();
  var titles = [];
  var ids = [];
  var urls = [];
  var names = [];
  var rates = [];
  var models = [];

  for (var i = 0; i < selected.length; i++) {
    titles.push(selected[i].title);
    ids.push(selected[i].id);
    urls.push(selected[i].url);
    names.push(selected[i].name);
    rates.push(selected[i].rate);
    models.push(selected[i].model);
  }

  var inputValue = titles.join('/');
  options.elem.val(inputValue);

  if (titles.length) {
    that.elemShow.html(
      $.map(titles, function (title) {
        return '<span class="' + CONST.SHOW_TEXT + '-item">' + escapeHtml(title) + '</span>';
      }).join('<i class="layui-icon layui-icon-right"></i>'),
    );
  } else {
    that.elemShow.html(
      '<span class="' +
        CONST.SHOW_TEXT +
        '">' +
        escapeHtml(options.placeholder) +
        '</span>',
    );
  }

  return {
    data: inputValue,
    ids: ids,
    urls: urls,
    names: names,
    rates: rates,
    models: models,
  };
};

Class.prototype.restoreSelection = function () {
  var that = this;
  var value = String(that.config.elem.val() || '');

  if (!value) {
    that.updateDisplay();
    return;
  }

  var ids = that.resolveSelectedIds(value.split('/'));
  var currentPid = that.config.id;

  for (var i = 0; i < ids.length; i++) {
    var id = ids[i];
    if (i > 0) {
      that.elemPop.append(that.renderColumn(currentPid));
    }

    var target = that.elemPop.find('ul').eq(i).find('li[data-id="' + id + '"]');
    if (!target.length) {
      break;
    }

    target.addClass(CONST.ACTIVE);
    currentPid = id;
  }

  if (ids.length) {
    that.elemPop.append(that.renderColumn(currentPid));
  }

  that.updateDisplay();
};

Class.prototype.scrollActiveIntoView = function () {
  this.elemPop.find('ul').each(function () {
    var list = $(this);
    var active = list.children('li.' + CONST.ACTIVE);

    if (!active[0]) {
      return;
    }

    var top = active.position().top;
    var listHeight = list.height();
    var itemHeight = active.outerHeight() || 0;

    if (top > listHeight - itemHeight) {
      list.scrollTop(top + list.scrollTop() - listHeight + itemHeight + 6);
    } else if (top < 0) {
      list.scrollTop(top + list.scrollTop() - 6);
    }
  });
};

Class.prototype.close = function () {
  if (this.config.type === 'absolute') {
    this.elemPop.hide();
  }
};

Class.prototype.open = function () {
  if (this.config.type === 'absolute') {
    this.elemPop.show();
    this.scrollActiveIntoView();
  }
};

Class.prototype.destroy = function () {
  var that = this;
  var elem = that.config.elem;
  var parent = elem.parent();
  var eventNs = that.cache('eventNs');

  if (eventNs) {
    parent.off(eventNs);
    $(document).off(eventNs);
    $(window).off(eventNs);
  }

  parent.find('> .' + CONST.SHOW + ', > .' + CONST.POP).remove();
  parent.removeData('selectYInstance');
};

Class.prototype.render = function () {
  var that = this;
  var options = that.config;
  var elem = options.elem;
  var eventNs = '.selectY-' + that.index;

  that.destroy();

  if (!elem.parent().hasClass(CONST.ROOT)) {
    elem.wrap('<div class="' + CONST.ROOT + '"></div>');
  }

  that.elemBox = elem.parent();
  that.elemBox.data('selectYInstance', that);

  that.elemShow = $('<span class="' + CONST.SHOW + '"></span>');
  that.elemPop = $(
    '<div class="' +
      CONST.POP +
      (options.type === 'static' ? ' ' + CONST.STATIC_POP : '') +
      '"></div>',
  );

  elem.after(that.elemShow, that.elemPop);
  that.cache('eventNs', eventNs);

  that.elemPop.append(that.renderColumn(options.id));
  that.restoreSelection();

  that.elemBox.on('click' + eventNs, '.' + CONST.POP + ' ul li', function (event) {
    var item = $(this);

    if (item.hasClass(CONST.DISABLED)) {
      if (options.disabledTips) {
        layer.msg(options.disabledTips);
      }
      lay.stope(event);
      return false;
    }

    item.addClass(CONST.ACTIVE).siblings().removeClass(CONST.ACTIVE);
    item.parent().nextAll('ul').remove();

    var id = item.data('id');
    var hasChildren = item.hasClass(CONST.CHILD);

    if (hasChildren) {
      that.elemPop.append(that.renderColumn(id));
    }

    var callbackData = that.updateDisplay();

    if (hasChildren) {
      if (typeof options.change === 'function') {
        options.change.call(options, callbackData);
      }
    } else {
      that.close();
      if (typeof options.success === 'function') {
        options.success.call(options, callbackData);
      }
    }

    lay.stope(event);
  });

  that.elemBox.on('click' + eventNs, '.' + CONST.SHOW, function (event) {
    that.open();
    lay.stope(event);
  });

  if (options.type === 'absolute') {
    $(document).on('click' + eventNs, function () {
      that.close();
    });
    $(window).on('resize' + eventNs, function () {
      that.close();
    });
  }
};

var selectY = function (options) {
  return component.render(options);
};

$.extend(selectY, component);

export { selectY };
